<template>
  <div class="page-content">
    <page-template
      ref="tableOptionsRef"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';

  import api from '@/config/api';
  import userPower from '@/mixin/userPower';
  import date from '@/mixin/date'

  export default {
    mixins: [userPower, date],
  components: {
    pageTemplate
  },
  data() {
    return {
      searchOptions: {
        simple: [
          {label: '', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: "请输入业务单号"},
        ],
        complex: [
          {label: "选择日期", prop: "startTime", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
          // {
          //   label: "调价级别",
          //   type: "select",
          //   prop: "relateType",
          //   data: this.$utils.getCacheStatus('asPriceAdjustmentOrder.relateType'),
          //   change: this.getSelectParam,
          //   span: 12,
          // },
          {
            label: "门店",
            type: "select",
            prop: "storeId",
            span: 12,
            data: [],
            isHasAll: true,
            url: api.system.seStore
          },
          // {
          //   label: "货号",
          //   type: "input",
          //   prop: "otherName",
          //   span: 12,
          // },
          {
            label: "业务单号",
            type: "input",
            prop: "orderNo",
            span: 12,
          },
          {
            label: '审核状态',
            type: 'select',
            prop: 'reviewerStatus',
            defaultValue: 20,
            span: 12,
            data: [
              {label: '未审核', value: 20},
              {label: '已审核', value: 10}
            ],
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          callback: this.addGoods
        },
        {
          label: '刷新',
          code: 'refresh'
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.toEditPage,
          filter: (data) => {
            return data.reviewerStatus == 10 ? false : true;
          }
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
          filter: (data) => {
            return data.reviewerStatus == 10 ? false : true;
          }
        },
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            width: '180',
            align: 'center',
            showDetail: true
          },
          {
            label: '门店名称',
            prop: 'storeName',
            width: '80',
            align: 'center',
          },
          {
            label: '审核状态',
            prop: 'reviewerStatus',
            width: '80',
            align: 'center',
            enumData: this.$utils.getCacheStatus('asPriceAdjustmentOrder.reviewerStatus')
          },
          {label: '申请人', prop: 'voucherName', width: '80', align: 'center'},
          {label: '申请时间', prop: 'voucherDttm', width: '125', align: 'center'},
          {label: '审核人', prop: 'reviewerName', width: '80', align: 'center'},
          {label: '审核时间', prop: 'reviewerDttm', width: '125', align: 'center'},
          {label: '备注', prop: 'remarks', width: '80', align: 'center',},
        ],
        param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
        url: api.warehouse.adjustmentOrder
      },
      // 详情
      detailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0'
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            span: 12,
          },
          {
            label: '调价门店',
            prop: 'storeName',
            span: 12,
          },
        {
            label: '备注',
            prop: 'remarks',
            span: 12
          },
        ],
        tablesProp: {
          wePurchaseAdjustmentGoodsMapMVOList: {
            url: api.warehouse.purchaseAdjustmentQuery + "/detail/page",
            height: this.detailHeight,
            indexShow: true,
            tableName: "wePurchaseAdjustmentGoodsMapMVOList",
            columns: [
              {
                label: '序号',
                prop: 'indexShow',
                width: '50',
                align: "center"
              },
              {
                label: '条码',
                prop: 'barCode',
                width: '100',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '100',
              },
              {
                label: '规格',
                prop: 'specs',
                width: '100'
              },
              {
                label: '库存数量',
                prop: 'goodsNum',
                width: '100'
              },
              {
                label: '单位',
                prop: 'unitName',
                width: '100'
              },
              {
                label: '原成本价',
                prop: 'purchasePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '现成本价',
                prop: 'paPurchasePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '调价差额',
                type:'selfData',
                prop: 'differencePrice',
                align: 'center',
                width: '110',
                dealInfo: [
                  {label:"现成本价",prop:'paPurchasePrice'},
                  {label:"原成本价",prop:'purchasePrice'},
                  {label: "库存数量", prop: 'goodsNum'},
                ]
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: 200
              }
            ],
          }
        },
        // 打印的列表
        printTablesProp: {
          adjustmentGoodsMapList: {
            tableName: 'adjustmentGoodsMapList',
            showSummary: true,
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '100',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                width: '100',
              },
              {
                label: '规格',
                prop: 'specs',
                width: '100'
              },
              {
                label: '单位',
                prop: 'unitName',
                width: '100'
              },
              {
                label: '原进货价',
                prop: 'buyPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '进货价',
                type: 'inputNumber',
                prop: 'paBuyPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '零售价',
                type: 'inputNumber',
                prop: 'paRetailPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原最低零售价',
                prop: 'lowestPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '最低零售价',
                type: 'inputNumber',
                prop: 'paLowestPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原会员价',
                prop: 'vipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '会员价',
                type: 'inputNumber',
                prop: 'paVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原PLUS会员价',
                prop: 'plusVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '库存数量',
                prop: 'goodsNum',
                width: '100'
              },
              {
                label: 'PLUS会员价',
                type: 'inputNumber',
                prop: 'paPlusVipPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原批发价',
                prop: 'tradePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '批发价',
                type: 'inputNumber',
                prop: 'paTradePrice',
                align: 'center',
                width: '110',
              },
              {
                label: '原配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '配送价',
                type: 'inputNumber',
                prop: 'paDeliveryPrice',
                align: 'center',
                width: '110',
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '90',
              },
            ],
          },
        },
        url: api.warehouse.adjustmentOrder
      }
    };
  },
  created() {
    this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
    // this.setRelateStoreId(this.searchOptions.complex);
    this.setStore(this.searchOptions.complex)
  },
  mounted() {
    if (Object.keys(this.$route.params).length > 0) {
      if (this.$route.params.customQuery) {
        let str = this.$route.params.customQuery
        this.tableOptions.param = eval('(' + str + ')')
      }
    }
    this.$nextTick(()=>{
      this.tableOptions.url = api.warehouse.adjustmentOrder
      this.$refs['tableOptionsRef'].operationSuccess();
    })
  },
  methods: {
    toEditPage(row) {
      this.$router.push({path: '/warehouse/purchase/adjustmentAdd?id=' + row.id});
    },
    addGoods() {
      this.$router.push({path: '/warehouse/purchase/adjustmentAdd'});
    },
    getSelectParam(form) {
      let storeId = this.searchOptions.complex.filter(item => item.prop === 'storeId')[0];
      if (form.relateType === 10) {
        storeId.hidden = true;
      } else {
        //选择门店的时候，查询商户相应的门店
        storeId.hidden = false;
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/warehouse/purchase/adjustment.vue